var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryCustomerEnablement32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Customer-Enablement_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E27AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Customer-Enablement_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-8",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Customer-Enablement_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,21.936 L23.391,24.649 C22.895,20.715 20.755,17.67 17.982,16.675 C19.536,15.965 20.624,14.405 20.624,12.588 C20.624,10.106 18.605,8.088 16.124,8.088 C13.643,8.088 11.624,10.106 11.624,12.588 C11.624,14.372 12.676,15.903 14.184,16.63 C11.33,17.575 9.097,20.687 8.607,24.648 L4,21.936 L4,9.225 L16,2.161 L28,9.225 L28,21.936 Z M12.624,12.588 C12.624,10.658 14.194,9.088 16.124,9.088 C18.054,9.088 19.624,10.658 19.624,12.588 C19.624,14.518 18.054,16.088 16.124,16.088 C14.194,16.088 12.624,14.518 12.624,12.588 L12.624,12.588 Z M16,29 L9.438,25.138 L9.551,25.148 C9.959,20.688 12.731,17.326 16,17.326 C19.165,17.326 21.925,20.589 22.42,24.917 L23.061,24.844 L16,29 Z M16,1 L3,8.654 L3,22.507 L16,30.161 L29,22.507 L29,8.654 L16,1 Z",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryCustomerEnablement32);
export default __webpack_public_path__ + "static/media/Arch-Category_Customer-Enablement_32.34be92446063183700f2cb69843516cc.svg";
export { ForwardRef as ReactComponent };